import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';
import ArticleTemplate from '@/pages/article/components/ArticleTemplate';
import { templatesArticle } from '@/mocks/articleData';

export default function TemplatesArticle() {
  return (
    <>
      <Navbar />
      <ArticleTemplate article={templatesArticle} />
      <Footer />
    </>
  );
}